import { TryRefANoKeyFieldError } from "../../../../errors";
import { DatatypeModule } from "../../../../modules/datatype";
import { DatasetStore } from "../../../dataset-store/dataset-store";
import { DocumentTree } from "../../../result-tree/classes/document/document-tree";
import { FieldNode } from "../../../result-tree/classes/node/field-node";
import { SingleResultNode } from "../../../result-tree/classes/single-result";
import { IsArray, NotArray } from "../is-array/is-array";
import { GenerateProps, InputTreeNode } from "../node/input-tree-node";
import { NodeRoute } from "../node/value-object/route";
import { NotNull, PossibleNull } from "../possible-null/possible-null";
import { Count } from "./value-object/count";
import { Values } from "./value-object/values";

interface GetValuesProps {
  currentDocument: DocumentTree;
  store: DatasetStore;
}

export class PickValueNode extends InputTreeNode {
  constructor(
    private readonly datatypeModule: DatatypeModule,
    route: NodeRoute,
    isArray: IsArray,
    possibleNull: PossibleNull,
    private readonly count: Count,
    private readonly values: Values,
  ) {
    super(route, isArray, possibleNull);
  }

  /**
   * Los elementos de un array no son campos, por lo que no llevan la
   * configuracion de nulos del campo: `possibleNull` decide si el valor del
   * campo es un array o `null`, no si cada elemento lo es.
   */
  getNoArrayNode(): InputTreeNode {
    return new PickValueNode(
      this.datatypeModule,
      this.route,
      new NotArray(),
      new NotNull(),
      this.count,
      this.values,
    );
  }

  checkIfFieldExists(fieldTreeRoute: string[]): boolean {
    if (fieldTreeRoute.length === 0) {
      throw new TryRefANoKeyFieldError(this.getRouteString());
    } else {
      return false;
    }
  }

  private async getValues({
    currentDocument,
    store,
  }: GetValuesProps): Promise<unknown[]> {
    const result: unknown[] = [];
    const banned: number[] = [];

    const limit = await this.count.limit({
      store: store,
      currentDocument: currentDocument,
    });

    if (limit === this.values.length()) {
      return this.values.values();
    } else {
      let i = 0;

      while (i < limit) {
        const index = this.generateIndex(banned);

        banned.push(index);
        result.push(this.values.get(index));

        i++;
      }

      return result;
    }
  }

  private generateIndex(banned: number[]): number {
    let num = this.datatypeModule.int({
      min: 0,
      max: this.values.length(),
    });

    while (banned.includes(num)) {
      num = this.datatypeModule.int({ min: 0, max: this.values.length() });
    }

    return num;
  }

  async generate(props: GenerateProps): Promise<FieldNode> {
    return new SingleResultNode({
      name: this.getName(),
      value: await this.getValues(props),
    });
  }
}
